import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (!detail) return "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : ""))
      .filter(Boolean)
      .join(" ");
  return String(detail);
}

export const SERVICE_LABELS = {
  garten: "Gartenservice",
  hausmeister: "Hausmeisterservice",
  umzug: "Umzugshilfe & Tragehilfe",
  entruempelung: "Entrümpelung",
  tier: "Tierbetreuung",
  design: "Clothing & Design",
  autosuche: "Autosuche",
  websites: "Website-Erstellung",
  webdesign: "Webdesign / Online-Shop",
  clothing_design: "Clothing Design",
  clothing_brand: "Clothing Brand Aufbau",
  mehrere: "Mehrere Leistungen (Kombi-Angebot)",
  regelmaessig: "Regelmäßige Betreuung (nur auf Anfrage)",
  sonstiges: "Sonstiges",
};

// Neue Positionierung (JUSTIN WEB DESIGN & CLOTHING): nur diese Leistungen
// werden im Projektstart-Formular angeboten. Alte Keys bleiben für
// Bestandsdaten im Admin gültig.
export const PROJECT_SERVICES = {
  webdesign: "Webdesign / Online-Shop",
  clothing_design: "Clothing Design",
  clothing_brand: "Clothing Brand Aufbau",
  sonstiges: "Etwas anderes",
};
